<template>
  <div>
    <div class="mt-2 mx-3">
      <div v-if="signatures">
        <div
          v-for="signature in archivedSignatures"
          v-bind:key="signature.transactionId"
          class="signature-documents-row"
        >
          <h2>Téléchargez les documents de la signature {{signatureSteps.find(step => step.value === signature.step).text}}</h2>

          <v-layout align-center justify-center row fill-height>
            <v-flex class="d-flex d-flex-center">
              <div class="document-button-container">
                <v-btn color="secondary" class="document-button" @click="getSignedDocs(signature.transactionId)">Recevoir les fichiers signés par mail</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <DocumentsToSend
        :folders="folders"
        :documents="files"
        @upload="reload"
      ></DocumentsToSend>
    </div>

    <v-snackbar v-model="showError" :timeout="7000">Une erreur a eu lieu</v-snackbar>
    <v-snackbar v-model="showSuccess" :timeout="7000">Les documents ont bien été envoyés</v-snackbar>
  </div>
</template>

<script>
import DocumentsToSend from "../components/documents/DocumentsToSend";
import { SIGNATURE_STEPS } from "../../../webapp-commons/data";
import {fetchHil} from "./../utils";

export default {
  components: { DocumentsToSend },
  data() {
    return {
      loading: true,
      signatureSteps: SIGNATURE_STEPS,
      showError: false,
      showSuccess: false
    };
  },

  async mounted() {
    await this.reload();
    this.loading = false;
  },

  computed: {
    projectId() {
      return this.$route.params.lease_id;
    },
    signatures() {
      return this.$store.state.currentProject ? this.$store.state.currentProject.signatures : [];
    },
    archivedSignatures() {
      return this.signatures.filter(
        signature => signature.status === "ARCHIVED"
      );
    },
    folders() {
      return this.$store.state.currentProjectDocuments.filter(
        ({ type }) => type === "folder"
      );
    },
    files() {
      return this.$store.state.currentProjectDocuments.filter(
        ({ type }) => type === "file"
      );
    }
  },

  methods: {
    async reload() {
      await this.$store.dispatch("fetchDocumentsForProject", {
        id: this.$route.params.lease_id
      });
      await this.$store.dispatch("fetchProject", {
        id: this.projectId
      });
    },
    signed(transaction) {
      if (this.$store.state.currentProject) {
        const signatory = transaction.signatories.find(signatory => signatory.email === this.$store.state.currentProject.userId);
        return signatory ? signatory.signed : false;
      }
      return false;
    },
    async getSignedDocs(transactionId) {
      let resp;
      try {
        resp = await fetchHil(`/signatures/send-docs-by-email/${this.$store.state.currentProject._id}/${transactionId}`, {
          method: "GET"
        });
      } catch (e) {
        this.showError = true;
        console.log(e);
        return;
      }

      const data = await resp.json();
      console.log(data);
      this.showSuccess = data.success;
    }
  }
};
</script>

<style>
.signature-documents-row {
  width: 100%;
  overflow: hidden;
}
.signature-documents-row .layout {
  width: 100%;
}
.signature-documents-row .flex {
  align-items: stretch;
  justify-content: space-between;
}
.document-button-container {
  flex-basis: 30% !important;
  flex-grow: 0 !important;
}
.document-button {
  font-size: 0.75rem;
  width: 100%;
  min-height: 36px;
  height: 100%;
  margin: 0;
}
.document-button .v-btn__content {
  width: 100%;
  height: 100%;
  padding: 10px 16px;
  white-space: normal;
}
</style>
